module.exports = __webpack_public_path__ + "img/logo-um-mf.fc7530e1.png";